export default __webpack_public_path__ + "static/media/pcwr.92d3b4c8.jpg";